import { ReactElement } from 'react'
import * as Styled from './Wallet.styled'

// Slip path opens LIFF in a new tab — same constant the main Wallet uses for
// the slip-flow fallback. Card path is handled inline on this domain.
const LIFF_TOPUP_URL = 'https://liff.line.me/2009888839-40FcF4w9?action=topup'

interface Props {
  cardEnabled: boolean
  // Display-only hint shown under the card option. Amount validation moved
  // to AmountInputModal after the user picks a method (Phase 9.D UX polish).
  cardMin: number
  onPickCard: () => void
  onClose: () => void
}

export default function MethodPicker({
  cardEnabled,
  cardMin,
  onPickCard,
  onClose,
}: Props): ReactElement {
  return (
    <Styled.ModalOverlay onClick={onClose}>
      <Styled.ModalCard onClick={(e) => e.stopPropagation()}>
        <Styled.ModalTitle>Choose Top-Up Method</Styled.ModalTitle>

        <Styled.OptionButton
          as='a'
          href={LIFF_TOPUP_URL}
          target='_blank'
          rel='noopener noreferrer'
          onClick={onClose}
        >
          <Styled.OptionTitle>Top Up via QR (LINE)</Styled.OptionTitle>
          <Styled.OptionHint>Minimum ฿50</Styled.OptionHint>
        </Styled.OptionButton>

        {cardEnabled && (
          <Styled.OptionButton type='button' onClick={onPickCard}>
            <Styled.OptionTitle>Credit / Debit Card</Styled.OptionTitle>
            <Styled.OptionHint>
              Minimum ฿{cardMin.toLocaleString()}
            </Styled.OptionHint>
          </Styled.OptionButton>
        )}

        <Styled.ModalCloseBtn type='button' onClick={onClose}>
          Cancel
        </Styled.ModalCloseBtn>
      </Styled.ModalCard>
    </Styled.ModalOverlay>
  )
}
